import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Container } from 'react-bootstrap';

import EmptyCart from '../components/EmptyCart';
import withAsyncLifecycle from '../../core/hoc/async-lifecycle';
import WaitingPayment from '../components/WaitingPayment';
import { selectCartCurrency, selectCartTickets, selectCartWaitingPayment } from '../selectors';
import { selectHttpInfo } from '../../core/selectors/http';
import { getCartTickets } from '../actions';
import { getUsername } from '../../core/actions/auth';
import { selectAuthStatus } from '../../core/selectors/auth';
import { AUTH_REQUEST_NAME, CART_TICKETS_REQUEST_NAME } from '../api/config';
import { STATUS_AUTH_IDLE } from '../../core/reducers/auth';

const useLoadingCartStep = (CartStepContent) => {
    const tickets = useSelector(selectCartTickets);
    const currency = useSelector(selectCartCurrency);
    const cartRequest = useSelector((state) => selectHttpInfo(state, CART_TICKETS_REQUEST_NAME));
    const authRequest = useSelector((state) => selectHttpInfo(state, AUTH_REQUEST_NAME));
    const waitingPayment = useSelector(selectCartWaitingPayment);
    const isFetching = cartRequest.isFetching || authRequest.isFetching;
    const isError = cartRequest.isError || authRequest.isError;

    const dispatch = useDispatch();
    const status = useSelector(selectAuthStatus);
    useEffect(() => {
        const handlePageShow = (event) => {
            if (event.persisted) {
                window.location.reload();
            }
        };
        window.addEventListener('pageshow', handlePageShow);
        dispatch(getCartTickets());
        if (status === STATUS_AUTH_IDLE) {
            dispatch(getUsername());
        }
        return () => {
            window.removeEventListener('pageshow', handlePageShow);
        };
    }, []);
    const getWrappedComponent = () => {
        if (waitingPayment) {
            return WaitingPayment;
        }
        if (tickets && tickets.length) {
            return CartStepContent;
        }
        return EmptyCart;
    };
    const CartStepWithAsyncLifecycle = withAsyncLifecycle(getWrappedComponent(), {
        isFetching,
        isError,
    });
    return (
        <div className="cart-container">
            <Container>
                <CartStepWithAsyncLifecycle tickets={tickets} currency={currency}/>
            </Container>
        </div>
    );
};
export default useLoadingCartStep;
